var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCameraHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "#EEEFFF",
    stroke: "#E1E1E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.313 21.25C15.313 18.6612 17.4117 16.5625 20.0005 16.5625C22.5894 16.5625 24.688 18.6612 24.688 21.25C24.688 23.8388 22.5894 25.9375 20.0005 25.9375C17.4117 25.9375 15.313 23.8388 15.313 21.25ZM20.0005 18.4375C18.4472 18.4375 17.188 19.6967 17.188 21.25C17.188 22.8033 18.4472 24.0625 20.0005 24.0625C21.5538 24.0625 22.813 22.8033 22.813 21.25C22.813 19.6967 21.5538 18.4375 20.0005 18.4375Z",
    fill: "#5463FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2707 12.1875C16.9642 12.1875 15.9051 13.2466 15.9051 14.5531C15.9051 15.3855 15.2661 16.0785 14.4364 16.1459L11.6494 16.3723C11.1022 16.4167 10.6521 16.8214 10.55 17.3608C9.98907 20.3233 9.94725 23.3608 10.4264 26.3376L10.548 27.0928C10.6628 27.8061 11.2498 28.3487 11.9699 28.4072L14.3978 28.6044C18.1268 28.9072 21.8742 28.9072 25.6033 28.6044L28.0312 28.4072C28.7513 28.3487 29.3383 27.8061 29.4531 27.0928L29.5747 26.3376C30.0538 23.3607 30.012 20.3233 29.4511 17.3608C29.3489 16.8214 28.8989 16.4167 28.3517 16.3723L25.5647 16.1459C24.735 16.0785 24.0959 15.3855 24.0959 14.5531C24.0959 13.2466 23.0368 12.1875 21.7304 12.1875H18.2707ZM14.0377 14.2971C14.1701 12.0743 16.0146 10.3125 18.2707 10.3125H21.7304C23.9864 10.3125 25.831 12.0743 25.9633 14.2971L28.5035 14.5034C29.8921 14.6162 31.0341 15.6431 31.2933 17.012C31.8947 20.1879 31.9395 23.4442 31.4258 26.6355L31.3043 27.3908C31.0523 28.9565 29.7636 30.1477 28.183 30.2761L25.7551 30.4732C21.925 30.7843 18.0761 30.7843 14.246 30.4732L11.8181 30.2761C10.2374 30.1477 8.9488 28.9565 8.69678 27.3908L8.57522 26.6355C8.06155 23.4442 8.10639 20.1879 8.70773 17.012C8.96693 15.6431 10.109 14.6162 11.4976 14.5034L14.0377 14.2971Z",
    fill: "#5463FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraHover);
export default __webpack_public_path__ + "static/media/camera_hover.d3e42934168f6730eea6e4e94f58431c.svg";
export { ForwardRef as ReactComponent };